import path from 'ramda/src/path'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, { moduleKey, fieldDescPath }) => path(
	[moduleIdFromKey(moduleKey), ...fieldDescPath, 'fieldUnauthText'],
	moduleDescriptions,
)
